import { Component } from '@angular/core';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './loader.component.html'
})
export class LoaderComponent {}
